import { render, staticRenderFns } from "./searchRole.vue?vue&type=template&id=2e8d0d96&scoped=true&"
import script from "./searchRole.vue?vue&type=script&lang=js&"
export * from "./searchRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8d0d96",
  null
  
)

export default component.exports